// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__30mwC","title":"FrontImage_title__39BYF"};